export default function About() {
  return (
    <div className="about">
        <p>While the UK isn’t widely known for seismic activity, it does typically experience a small number of 
          earthquakes each year with magnitudes of 1.0 or greater. Select a year to explore the locations 
          and magnitudes of earthquakes recorded in or near the UK during that period.</p>
    </div>
  )
}
